import React from 'react';
import compose from 'lodash/fp/compose';
import { connect } from 'react-redux';

import { LoadingSpinner } from 'legacy-packages/ft-cb';

import withAggregateResults from './withAggregateResults';
import withSyncedDatasets from './withSyncedDatasets';
import aggregation from './aggregation';
import ChartResults from '../ChartResults/ChartResults';
import ErrorMessage from './ErrorMessage';
import AssessmentInformedResultsSummary from '../AssessmentInformedResultsSummary/AssessmentInformedResultsSummary';

/**
 * majority of the code af this module "chameleon/legacy/src/components/assessment/Results/SummaryReport"
 * was moved from the aggregated reports of PREAP legacy as is, with my best effort to address some of
 * the pain points in the reasonable timeframe.
 * - Use default values of feature flags and refactor.
 * - Decompose components when possible, use composition.
 * - Move components to separate folders and files.
 * - Remove support of the final exam and pilot assessments.
 *
 * Issues remain
 * - Performance Tiers are hardcoded at these components to the PREAP.
 * - ft-cb is used in many places, except where the replacement component from "ui-stack" was a straightforward option.
 * - Styles are not Tailwind-ed, neither use modules.
 * - Expect some other artifacts from the old codebase, like multiply components per file.
 */
const SummaryReportContainer = ({
  studentDataset,
  datasetsLoaded,
  providerError,
  lastScoreByTag,
  lastScoreByItem,
  questionDataset,
  assignments,
  classAveragePoints,
  totalAssessmentPoints,
  subject,
  userData,
  showLearningCheckpointEnhancedTab,
  useClassroomResourceAddress,
}) => {
  const { me } = userData;
  const isStudentLoggedIn = me.isStudent;

  if (isStudentLoggedIn) {
    return (
      <ErrorMessage>
        You do not have permission to view this report
      </ErrorMessage>
    );
  }

  const { data, error } = aggregation({
    studentDataset,
    questionDataset,
    classAveragePoints,
    totalAssessmentPoints,
    assignments,
  });

  if (!datasetsLoaded) {
    return <LoadingSpinner />;
  }

  if (error || providerError) {
    return <ErrorMessage>There was an error loading the results.</ErrorMessage>;
  }

  return (
    <ChartResults data={data} amountOfStudents={data.studentData.length}>
      <AssessmentInformedResultsSummary
        subject={subject}
        userData={userData}
        assignments={assignments}
        questionDataset={questionDataset}
        lastScoreByTag={lastScoreByTag}
        lastScoreByItem={lastScoreByItem}
        showLearningCheckpointEnhancedTab={showLearningCheckpointEnhancedTab}
        useClassroomResourceAddress={useClassroomResourceAddress}
      />
    </ChartResults>
  );
};

export default compose(
  connect((state) => ({
    subject: state.subject.data,
    userData: state.userData,
    showLearningCheckpointEnhancedTab:
      state.featureFlag.preap_lc_reporting_enhancements,
    useClassroomResourceAddress:
      state.featureFlag.preap_outline_use_resources_route,
  })),
  withAggregateResults,
  withSyncedDatasets,
)(SummaryReportContainer);
